import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const api = {
  // health
  ping: () => http.get("/").then(r => r.data),

  // users
  listUsers: () => http.get("/users").then(r => r.data),
  createUser: (body) => http.post("/users", body).then(r => r.data),
  deleteUser: (real) => http.delete(`/users/${encodeURIComponent(real)}`).then(r => r.data),

  // pool
  listPool: () => http.get("/pool").then(r => r.data),
  addPool: (numbers) => http.post("/pool", { numbers }).then(r => r.data),
  deletePool: (n) => http.delete(`/pool/${encodeURIComponent(n)}`).then(r => r.data),

  // mappings
  listMappings: () => http.get("/mappings").then(r => r.data),
  burnMapping: (id) => http.post(`/mappings/${id}/burn`).then(r => r.data),

  // burn list
  listBurns: () => http.get("/burn-list").then(r => r.data),
  unblock: (id) => http.delete(`/burn-list/${id}`).then(r => r.data),

  // vcards
  listVcards: () => http.get("/vcards").then(r => r.data),
  vcardFileUrl: (id) => `${API}/vcards/${id}/file`,

  // logs
  listLogs: (limit = 200) => http.get(`/logs?limit=${limit}`).then(r => r.data),
  clearLogs: () => http.delete("/logs").then(r => r.data),

  // stats
  stats: () => http.get("/stats").then(r => r.data),

  // simulator / webhook
  simulate: (body) => http.post("/simulate/text", body).then(r => r.data),

  // invite codes (admin)
  generateInvites: (count = 1) => http.post("/admin/invite-codes", { count }).then(r => r.data),
  listInvites: () => http.get("/admin/invite-codes").then(r => r.data),
  deleteInvite: (id) => http.delete(`/admin/invite-codes/${id}`).then(r => r.data),

  // proxy pool (admin)
  listProxyPool: () => http.get("/admin/proxy-pool").then(r => r.data),
  addProxyPool: (numbers) => http.post("/admin/proxy-pool", { numbers }).then(r => r.data),
  deleteProxyPool: (id) => http.delete(`/admin/proxy-pool/${id}`).then(r => r.data),

  // signup (public)
  validateInvite: (code) => http.post("/invite/validate", { code }).then(r => r.data),
  signup: (body) => http.post("/signup", body).then(r => r.data),
  signupStatus: (sid) => http.get(`/signup/status/${sid}`).then(r => r.data),

  // config (public)
  config: () => http.get("/config").then(r => r.data),
};

export default api;
